import StarsRating from './stars-rating';

export default StarsRating;
